// admin/src/Component/PinterestConversion/Edit.js

import React from 'react';
import {
    regex,
    Edit,
    SimpleForm,
    TextInput,
    required,
    ReferenceInput,
    SelectInput,
    BooleanInput,
    TextField
} from 'react-admin';


const validateUrl = regex(/^(ftp|http|https):\/\/[^ "]+$/, 'Must be a valid url');
const requiredUrl = [required(), validateUrl];

export const PinterestConversionEdit = (props) => {

    return (
    <Edit title="Edit pinterest conversion " { ...props }>
        <SimpleForm>

            <TextField source="id" />

            <BooleanInput source="active" label="Active" />
            <BooleanInput source="pinterest_enabled" label="Also throw pinterest pixel" />
            <TextInput source="name" label="Name" validate={ required() } />
            <TextInput source="url" label="URL" validate={ requiredUrl } />
            <TextInput source="data_layer" label="Data layer" validate={ required() } />

            <ReferenceInput label="SameSite" source="cookie_consent_same_site" reference="cookie-consent-same-sites" validate={ required() }>
                <SelectInput optionText="name" />
            </ReferenceInput>

            <TextInput source="currency" label="Currency" defaultValue="EUR" validate={ required() } />
            <TextInput source="ad_account_id" label="Ad AccountID" validate={ required() } />
            <TextInput source="pixel_id" label="Pixel ID" validate={ required() } />
            <TextInput source="access_token" label="Access token" validate={ required() } />

        </SimpleForm>
    </Edit>
    );
};
